const FORMAT_MIME: Record<string, string> = {
  csv: 'text/csv;charset=utf-8',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}

export function downloadBase64File(
  base64: string,
  filename: string,
  format: string,
): void {
  const bytes = base64ToBytes(base64)
  const mime = FORMAT_MIME[format] ?? 'application/octet-stream'
  const blob = new Blob([bytes.buffer as ArrayBuffer], { type: mime })
  triggerDownload(blob, filename)
}

export function downloadBlob(blob: Blob, filename: string): void {
  triggerDownload(blob, filename)
}

function base64ToBytes(base64: string): Uint8Array {
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index)
  }
  return bytes
}

function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
}
